<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style lang="less">
ul,
li {
  list-style: none;
}
svg {
  vertical-align: middle;
}
.vue-waterfall-easy-scroll {
  overflow: inherit !important;
}
</style>
